import { apiFetch } from './client'

export interface GameScore {
  id: number | null
  portfolioId: string
  gameName: string
  score: number
  solCollected: number
  levelReached: number
  playedAt: string | null
}

export interface LeaderboardData {
  scores: GameScore[]
  myBest: GameScore
}

export function submitScore(data: {
  gameName: string
  score: number
  solCollected: number
  levelReached: number
}): Promise<GameScore> {
  return apiFetch<GameScore>('/api/games/scores', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export function fetchLeaderboard(gameName = 'captain_sol', limit = 20): Promise<LeaderboardData> {
  return apiFetch<LeaderboardData>(`/api/games/scores/leaderboard?gameName=${encodeURIComponent(gameName)}&limit=${limit}`)
}

export function fetchMyScores(): Promise<GameScore[]> {
  return apiFetch<GameScore[]>('/api/games/scores/my')
}
